import { getNodeAttrs, isNodeActive, insertParagraph, setActiveTool, isPositiveNumber } from "../../../commands/custom-commands";
import { setBlockType } from "prosemirror-commands";
import {
  customSchema,
  validParagraphClasses,
  validFontColorClasses,
  validBackgroundColorClasses,
  validFontSizeClasses,
  validAlignTypes,
  validMarginBottomClasses,
  validParagraphValues,
  validFontColorValues,
  validBackgroundColorValues,
  validFontSizeValues,
  validAlignValues,
  validMarginBottomValues
} from "../../../schemas/custom-schema";

export default class ParagraphTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName = "--paragraph-anchor";
    this.buttonElement.dataset.action = "paragraph";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title = "Párrafo";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Párrafo";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Párrafo";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const targetInputContainer = document.createElement("div"),
      targetLabel = document.createElement("label"),
      buttonsContainer = document.createElement("div"),
      typeLabel = document.createElement("label"),
      idLabel = document.createElement("label"),
      colorLabel = document.createElement("label"),
      sizeLabel = document.createElement("label"),
      bgColorLabel = document.createElement("label"),
      alignLabel = document.createElement("label"),
      marginBottomLabel = document.createElement("label"),
      typeContainer = document.createElement("div"),
      idContainer = document.createElement("div"),
      colorContainer = document.createElement("div"),
      alignContainer = document.createElement("div"),
      bgColorContainer = document.createElement("div"),
      sizeContainer = document.createElement("div"),
      marginBottomContainer = document.createElement("div"),
      marginLeftLabel = document.createElement("label"),
      marginLeftContainer = document.createElement("div");
    let defaultOption, options;

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog two-columns";
    this.dialogElement.style.positionAnchor = "--paragraph-anchor";

    this.typeDropdown = document.createElement("select");
    this.typeDropdown.className = "editor-dropdown";
    defaultOption = document.createElement("option");
    options = validParagraphClasses.map(option => {
      const opt = document.createElement("option");
      opt.textContent = option.label;
      opt.value = option.value;
      this.typeDropdown.appendChild(opt);

      return opt;
    });
    defaultOption.value = "";
    defaultOption.textContent = "Normal";
    options.unshift(defaultOption);
    options.forEach(option => this.typeDropdown.appendChild(option));
    typeLabel.textContent = "Tipo";
    typeLabel.className = "editor-dialog-label";
    typeContainer.className = "editor-dialog-container";
    typeContainer.appendChild(typeLabel);
    typeContainer.appendChild(this.typeDropdown);

    this.colorDropdown = document.createElement("select");
    this.colorDropdown.className = "editor-dropdown";
    defaultOption = document.createElement("option");
    options = validFontColorClasses.map(option => {
      const opt = document.createElement("option");
      opt.textContent = option.label;
      opt.value = option.value;

      return opt;
    });
    defaultOption.value = "";
    defaultOption.textContent = "Por defecto";
    options.unshift(defaultOption);
    options.forEach(option => this.colorDropdown.appendChild(option));
    colorLabel.textContent = "Color de fuente";
    colorLabel.className = "editor-dialog-label";
    colorContainer.className = "editor-dialog-container";
    colorContainer.appendChild(colorLabel);
    colorContainer.appendChild(this.colorDropdown);

    this.bgColorDropdown = document.createElement("select");
    this.bgColorDropdown.className = "editor-dropdown";
    defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Por defecto";
    options = validBackgroundColorClasses.map(option => {
      const opt = document.createElement("option");
      opt.textContent = option.label;
      opt.value = option.value;

      return opt;
    });
    options.unshift(defaultOption);
    options.forEach(option => this.bgColorDropdown.appendChild(option));
    bgColorLabel.textContent = "Color de fondo";
    bgColorLabel.className = "editor-dialog-label";
    bgColorContainer.className = "editor-dialog-container";
    bgColorContainer.appendChild(bgColorLabel);
    bgColorContainer.appendChild(this.bgColorDropdown);

    this.fontSizeDropdown = document.createElement("select");
    this.fontSizeDropdown.className = "editor-dropdown";
    defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Por defecto";
    options = validFontSizeClasses.map(option => {
      const opt = document.createElement("option");
      opt.textContent = option.label;
      opt.value = option.value;

      return opt;
    });
    options.unshift(defaultOption);
    options.forEach(option => this.fontSizeDropdown.appendChild(option));
    sizeLabel.textContent = "Tamaño de fuente";
    sizeLabel.className = "editor-dialog-label";
    sizeContainer.className = "editor-dialog-container";
    sizeContainer.appendChild(sizeLabel);
    sizeContainer.appendChild(this.fontSizeDropdown);

    this.alignDropdown = document.createElement("select");
    this.alignDropdown.className = "editor-dropdown";
    defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Por defecto";
    options = validAlignTypes.map(option => {
      const opt = document.createElement("option");
      opt.textContent = option.label;
      opt.value = option.value;

      return opt;
    });
    options.unshift(defaultOption);
    options.forEach(option => this.alignDropdown.appendChild(option));
    alignLabel.textContent = "Alineación";
    alignLabel.className = "editor-dialog-label";
    alignContainer.className = "editor-dialog-container";
    alignContainer.appendChild(alignLabel);
    alignContainer.appendChild(this.alignDropdown);

    this.marginBottomDropdown = document.createElement("select");
    this.marginBottomDropdown.className = "editor-dropdown";
    defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Por defecto";
    options = validMarginBottomClasses.map(option => {
      const opt = document.createElement("option");
      opt.textContent = option.label;
      opt.value = option.value;

      return opt;
    });
    options.unshift(defaultOption);
    options.forEach(option => this.marginBottomDropdown.appendChild(option));
    marginBottomLabel.textContent = "Margen contra siguiente elemento";
    marginBottomLabel.className = "editor-dialog-label";
    marginBottomContainer.className = "editor-dialog-container";
    marginBottomContainer.appendChild(marginBottomLabel);
    marginBottomContainer.appendChild(this.marginBottomDropdown);

    this.idInput = document.createElement("input");
    //this.idInput.setAttribute("placeholder", "Identificador");
    this.idInput.className = "editor-input";
    this.idInput.type = "text";
    idLabel.textContent = "Identificador (opcional)";
    idLabel.className = "editor-dialog-label";
    idContainer.className = "editor-dialog-container";
    idContainer.appendChild(idLabel);
    idContainer.appendChild(this.idInput);

    this.marginLeftInput = document.createElement("input");
    this.marginLeftInput.className = "editor-input";
    this.marginLeftInput.setAttribute("type", "number");
    this.marginLeftInput.setAttribute("placeholder", "Medida base: 1ch");
    marginLeftLabel.textContent = "Margen a la izquierda";
    marginLeftLabel.className = "editor-dialog-label";
    marginLeftContainer.className = "editor-dialog-container";
    marginLeftContainer.appendChild(marginLeftLabel);
    marginLeftContainer.appendChild(this.marginLeftInput);

    this.submitButton = document.createElement("button");
    this.submitButton.type = "button";
    this.submitButton.className = "editor-button";
    this.submitButton.textContent = "Agregar";

    buttonsContainer.className = "editor-buttons-container";
    buttonsContainer.appendChild(this.submitButton);

    this.dialogElement.appendChild(typeContainer);
    this.dialogElement.appendChild(alignContainer);
    this.dialogElement.appendChild(colorContainer);
    this.dialogElement.appendChild(bgColorContainer);
    this.dialogElement.appendChild(sizeContainer);
    this.dialogElement.appendChild(marginBottomContainer);
    this.dialogElement.appendChild(idContainer);
    this.dialogElement.appendChild(marginLeftContainer);

    this.dialogElement.appendChild(buttonsContainer);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.submitAction = this.submitButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.submitButton.addEventListener("click", this.submitAction);
  }

  update(view) {
    const nodeAttrs = getNodeAttrs(view.state, customSchema.nodes.paragraph),
      isEnabled = insertParagraph({ type: "normal" })(view.state, null, view);
    if(nodeAttrs) { 
      this.idInput.value = nodeAttrs.id;
      this.typeDropdown.value = nodeAttrs.type || "";
      this.colorDropdown.value = nodeAttrs.color || "";
      this.bgColorDropdown.value = nodeAttrs.bgColor || "";
      this.alignDropdown.value = nodeAttrs.align || "";
      this.fontSizeDropdown.value = nodeAttrs.size || "";
      this.marginBottomDropdown.value = nodeAttrs.marginBottom || "";
      this.marginLeftInput.value = nodeAttrs.marginLeft || "";
      this.buttonElement.setAttribute("aria-pressed", "true");
    } else {
      this.idInput.value = null;
      this.typeDropdown.value = this.typeDropdown.options[0].value;
      this.colorDropdown.value = this.colorDropdown.options[0].value;
      this.bgColorDropdown.value = this.bgColorDropdown.options[0].value;
      this.alignDropdown.value = this.alignDropdown.options[0].value;
      this.fontSizeDropdown.value = this.fontSizeDropdown.options[0].value;
      this.marginBottomDropdown.value = this.marginBottomDropdown.options[0].value;
      this.marginLeftInput.value = null;
      this.buttonElement.setAttribute("aria-pressed", "false");
    }

    this.buttonElement.disabled = !isEnabled;
    this.view = view;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.submitButton.removeEventListener("click", this.submitAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.idInput = null;
    this.colorDropdown = null;
    this.bgColorDropdown = null;
    this.fontSizeDropdown = null;
    this.alignDropdown = null;
    this.typeDropdown = null;
    this.marginBottomDropdown = null;
    this.marginLeftInput = null;
    this.submitButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.submitAction = null;
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  submitButtonClickCallback() {
    return (event) => {
      event.preventDefault();
      let { value: id } = this.idInput,
        { value: color } = this.colorDropdown,
        { value: bgColor } = this.bgColorDropdown,
        { value: align } = this.alignDropdown,
        { value: size } = this.fontSizeDropdown,
        { value: type } = this.typeDropdown,
        { value: marginBottom } = this.marginBottomDropdown,
        { value: marginLeft } = this.marginLeftInput;

      if(!validFontColorValues.includes(color)) {
        color = null;
      }

      if(!validBackgroundColorValues.includes(bgColor)) {
        bgColor = null;
      }

      if(!validFontSizeValues.includes(size)) {
        size = null;
      }

      if(!validAlignValues.includes(align)) {
        align = null;
      }

      if(!validMarginBottomValues.includes(marginBottom)) {
        marginBottom = null;
      }

      if(!validParagraphValues.includes(type)) {
        type = null;
      }

      if(!isPositiveNumber(marginLeft)) {
        marginLeft = null;
      }

      insertParagraph({ id, color, bgColor, type, size, align, marginBottom, marginLeft })(this.view.state, this.view.dispatch, this.view);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}
